import axios from '@/api/axios';
import {clearParams} from '@/helpers/utils';

const getReportSelfVersions = (userId, specCode, skillType, teamId) =>
  axios.get(`/reports/${userId}/${specCode}/${skillType}${teamId ? `?team=${teamId}` : ''}`);

const getReportSelf = (reportName, userId, specCode, teamId, format = '', version) =>
  axios.get(
    `/report/${reportName}/${userId}?spec=${specCode}&format=${format}&version=${version}${
      teamId ? `&team=${teamId}` : ''
    }`
  );

const getReport360 = (reportName, userId, testId, teamId, format = '', roles) =>
  axios.get(`/report/${reportName}/${userId}`, {
    params: clearParams({
      spec: testId,
      team: teamId,
      format,
      roles,
    }),
  });

/*
  сравнение отчётов 360 пользователей внутри компании

  company_id (integer, required): ID компании
  date_end (string, optional): Конец периода,
  date_start (string, optional): Начало периода,
  skill_type (string, optional): Тип навыков = ['hard', 'soft'],
  spec_code (string, optional): Код специализации,
  target_field (string, optional): Имя значимого поля (С самооценкой или без) = ['experts', 'total'],
  user_ids (Array[integer], optional): Массив user_id
 */
const getReport360Compare = (
  companyId,
  specCode,
  dateStart,
  dateEnd,
  userIds,
  skillType,
  targetField
) =>
  axios.post(`/report/compare360/${companyId}`, {
    spec_code: specCode,
    date_start: dateStart,
    date_end: dateEnd,
    user_ids: userIds,
    skill_type: skillType,
    target_field: targetField,
  });

const getReportPersonal = (reportName, userId, teamId, format = '') =>
  axios.get(
    `/report/${reportName}/${userId}?spec=personal&format=${format}${
      teamId ? `&team=${teamId}` : ''
    }`
  );

// персональный отчет
const getReportBHPersonal = (skillType, blockId) =>
  axios.get(`/report/bh_personal/${skillType}/block/${blockId}/params`);

// командный отчет
const getReportBHPersonalTeam = (skillType, teamId) =>
  axios.get(`/report/bh_personal/${skillType}/team/${teamId}/params`);

const getReportTeam = (reportName, teamId, teamIds, specCode, format = '') =>
  axios.get(
    `/report/${reportName}/${teamId}?team=${teamIds}&format=${format}${
      specCode ? `&spec=${specCode}` : ''
    }`
  );

const getReportTeamSpecs = (skillType, teamId) =>
  axios.get(`/report/team_report_specializations/${skillType}/${teamId}`);

// Получить список команд с доступным типом отчета
const getReportTeamPersonal = (companyId, reportType) =>
  axios.get(`report/team_report_personal/${companyId}/${reportType}`);

const getReportTeamBHPersonal = (companyId, reportType, teamId = undefined) =>
  axios.get(`/report/bh_personal/${companyId}/${reportType}`, {
    params: {team_id: teamId},
  });

const getReportParams = (reportName, targetId) =>
  axios.get(`/report/${reportName}/${targetId}/params`);

const setReportParams = (reportName, targetId, data) =>
  axios.post(`/report/${reportName}/${targetId}/params`, data);

const uploadDiagram = (reportName, targetId, data) =>
  axios.post(`/report/${reportName}/${targetId}/upload`, data);

const generateReportToPDF = (data, format) =>
  axios.post('/report/pdf/generate', data, {
    responseType: format === 'pdf' ? 'blob' : 'json',
    params: {format_: format},
  });

const exportReport = (reportName, companyId, data) =>
  axios.post(`/report/${reportName}/${companyId}/export`, data, {responseType: 'blob'});

// Комментарии
const getCommentsParams = (reportName, targetId) =>
  axios.get(`/report/${reportName}/${targetId}/comment/params`);

const changeCommentsParams = (reportName, targetId, data) =>
  axios.post(`/report/${reportName}/${targetId}/comment/params`, data);

export default {
  getReportSelfVersions,
  getReportSelf,
  getReport360,
  getReport360Compare,
  getReportPersonal,
  getReportBHPersonal,
  getReportBHPersonalTeam,
  getReportTeam,
  getReportTeamSpecs,
  getReportTeamPersonal,
  getReportTeamBHPersonal,
  getReportParams,
  setReportParams,
  uploadDiagram,
  generateReportToPDF,
  exportReport,
  getCommentsParams,
  changeCommentsParams,
};
